/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExecutionStatus } from './ExecutionStatus';
import {
    ExecutionStatusFromJSON,
    ExecutionStatusFromJSONTyped,
    ExecutionStatusToJSON,
    ExecutionStatusToJSONTyped,
} from './ExecutionStatus';

/**
 * 
 * @export
 * @interface GetJobExecutionResponse
 */
export interface GetJobExecutionResponse {
    /**
     * 
     * @type {string}
     * @memberof GetJobExecutionResponse
     */
    executionId: string;
    /**
     * 
     * @type {Date}
     * @memberof GetJobExecutionResponse
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetJobExecutionResponse
     */
    endTime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetJobExecutionResponse
     */
    message: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJobExecutionResponse
     */
    error: string | null;
    /**
     * 
     * @type {ExecutionStatus}
     * @memberof GetJobExecutionResponse
     */
    status: ExecutionStatus;
    /**
     * 
     * @type {string}
     * @memberof GetJobExecutionResponse
     */
    scheduledBy: string | null;
}



/**
 * Check if a given object implements the GetJobExecutionResponse interface.
 */
export function instanceOfGetJobExecutionResponse(value: object): value is GetJobExecutionResponse {
    if (!('executionId' in value) || value['executionId'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('scheduledBy' in value) || value['scheduledBy'] === undefined) return false;
    return true;
}

export function GetJobExecutionResponseFromJSON(json: any): GetJobExecutionResponse {
    return GetJobExecutionResponseFromJSONTyped(json, false);
}

export function GetJobExecutionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetJobExecutionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'executionId': json['executionId'],
        'startTime': (new Date(json['startTime'])),
        'endTime': (json['endTime'] == null ? null : new Date(json['endTime'])),
        'message': json['message'],
        'error': json['error'],
        'status': ExecutionStatusFromJSON(json['status']),
        'scheduledBy': json['scheduledBy'],
    };
}

export function GetJobExecutionResponseToJSON(json: any): GetJobExecutionResponse {
    return GetJobExecutionResponseToJSONTyped(json, false);
}

export function GetJobExecutionResponseToJSONTyped(value?: GetJobExecutionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'executionId': value['executionId'],
        'startTime': value['startTime'].toISOString(),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
        'message': value['message'],
        'error': value['error'],
        'status': ExecutionStatusToJSON(value['status']),
        'scheduledBy': value['scheduledBy'],
    };
}

